import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ShoppingCart } from "lucide-react";
import api from "@/lib/api";
import { useCart } from "@/context/CartContext";
import { Button } from "@/components/ui/button";
import { Money, Badge } from "@/components/common";

export default function ProductDetail() {
  const { id } = useParams();
  const { addToCart } = useCart();
  const navigate = useNavigate();
  const [p, setP] = useState(null);
  useEffect(() => { api.get(`/products/${id}`).then(({ data }) => setP(data)); }, [id]);
  if (!p) return <div className="min-h-[60vh]" />;
  const price = p.discount_price || p.price;
  return (
    <div className="max-w-5xl mx-auto px-6 py-10 min-h-[60vh]" data-testid="product-detail-page">
      <div className="grid md:grid-cols-2 gap-10">
        <img src={p.images?.[0]} alt={p.name} className="w-full rounded-xl border border-border" />
        <div>
          <Badge tone="amber">{p.category}</Badge>
          <h1 className="font-heading text-3xl font-bold text-navy mt-3">{p.name}</h1>
          <div className="flex items-center gap-3 mt-4">
            <span className="font-heading text-3xl font-black text-navy"><Money amount={price} /></span>
            {p.discount_price > 0 && <span className="text-muted-foreground line-through"><Money amount={p.price} /></span>}
          </div>
          <p className="text-navy/70 mt-4">{p.description}</p>
          <p className="text-sm text-muted-foreground mt-2">In stock: {p.stock}</p>
          <div className="flex gap-3 mt-6">
            <Button className="viriks-amber text-white font-semibold" onClick={() => { addToCart({ type: "product", id: p.id, title: p.name, price, thumbnail: p.images?.[0] }); }} data-testid="pd-add-cart"><ShoppingCart size={16} className="mr-2" /> Add to Cart</Button>
            <Button variant="outline" onClick={() => navigate("/checkout", { state: { items: [{ type: "product", id: p.id, title: p.name, price, qty: 1 }] } })}>Buy Now</Button>
          </div>
        </div>
      </div>
    </div>
  );
}
